import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { WorkspaceDto, CreateWorkspaceDto } from '../dto/workspace.dto';
import {
  ProcessResult,
  QueryOptions,
  QueryResult,
} from '../components/common-dto/query.dto';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  constructor(private backend: BackendService) {}

  getWorkspaces(
    queryParams: QueryOptions
  ): Observable<QueryResult<WorkspaceDto>> {
    return this.backend.getQuery<WorkspaceDto>('workspace', queryParams);
  }

  getWorkspace(id: string): Observable<WorkspaceDto> {
    return this.backend.get<WorkspaceDto>(`workspace/${id}`);
  }

  createWorkspace(workspace: CreateWorkspaceDto): Observable<ProcessResult> {
    return this.backend.post<ProcessResult>('workspace', workspace);
  }

  updateWorkspace(
    id: string,
    workspace: WorkspaceDto
  ): Observable<ProcessResult> {
    return this.backend.put<ProcessResult>(`workspace/${id}`, workspace);
  }

  deleteWorkspace(id: string): Observable<ProcessResult> {
    return this.backend.delete<ProcessResult>(`workspace/${id}`);
  }

  /**
   * Get all workspaces without authentication (for public access)
   */
  getAllWorkspaces(): Observable<WorkspaceDto[]> {
    return this.backend.getUnauthenticated<WorkspaceDto[]>('workspace/all');
  }
}
